import { observer } from "@formily/react";

export const Summary = observer((props: any) => {
  if (!props.items) {
    return null;
  }

  return (
    <>
      {props.items.map((item: any, index: number) => (
        <dl key={index} className="grid grid-cols-2 gap-3">
          <dt className="min-w-[200px] font-bold">{item.label}</dt>
          <dd className="text-gray-600">{item.value}</dd>
        </dl>
      ))}
    </>
  );
});
